<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Formation de masse
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-text>
        <v-form ref="formEdit">
          <v-container fluid>
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="formationDeMasse.ll_formation"
                  label="Libellé de la Formation"
                  prepend-icon="person"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formationDeMasse.date_formation"
                      label="Date de la formation"
                      prepend-icon="mdi-calendar-cursor"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="fr"
                    v-model="formationDeMasse.date_formation"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="formationDeMasse.nombre_hommes_participants"
                  label="Nombre d'hommes participants"
                  prepend-icon="person"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  dense
                  v-model="formationDeMasse.nombre_femmes_participants"
                  label="Nombre de femmes participantes"
                  prepend-icon="mdi-face-woman-outline"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-btn rounded color="info" @click.stop="$router.go(-1)">Annuler</v-btn>
        <v-btn rounded color="primary" @click.stop="updateFormationDeMasse()"
          >Mettre à jour</v-btn
        >
      </v-card-actions>
    </v-card>
    <Navigation v-if="isSuperviseur" :elements="SuperviseurNavigation" />
    <Navigation v-if="isAdmin" :elements="AdminNavigation" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.getFormationDemasseById(this.$route.params.id);
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      formationDeMasse: {},
      menu2: false,
    };
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
    }),
  },
  methods: {
    updateFormationDeMasse() {
      const self = this;
      console.log(this.formationDeMasse);
      var ref = this.$firebase
        .firestore()
        .collection("formations")
        .doc(this.$route.params.id);

      return ref
        .update({
          ll_formation: self.formationDeMasse.ll_formation,
          date_formation: self.formationDeMasse.date_formation,
          nombre_hommes_participants:
            self.formationDeMasse.nombre_hommes_participants,
          nombre_femmes_participants:
            self.formationDeMasse.nombre_femmes_participants,
        })
        .then(function () {
          console.log("Document successfully updated!");
          self.$router.push("/");
         
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          self.$router.push("/");
         
        });
    },
    getFormationDemasseById(item) {
      const self = this;
      var ref = this.$firebase.firestore().collection("formations").doc(item);
      ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.formationDeMasse = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    ...mapActions({

    }),
  },
};
</script>

<style lang="scss" scoped></style>
